const path = require('path');

/** @type {import('next-i18next').UserConfig} */
const i18n = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'es', 'ru', 'zh', 'ar', 'fr', 'pt', 'it', 'tr', 'pl', 'ko', 'ro', 'el', 'hu'],
    localeDetection: false,
  },
  fallbackLng: 'en',
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  addPath: '/locales/{{lng}}/{{ns}}.missing.json',
  // loadPath: '/locales/{{lng}}/{{ns}}.json',
  backend: {
    loadPath: (lang, ns) => {
      if (typeof window === 'undefined') {
        return path.resolve(`public/locales/${lang}/${ns}.json`);
      } else {
        return `/locales/${lang}/${ns}.json`;
      }
    },
  },

  serializeConfig: false,
  saveMissing: false,
};

module.exports = i18n;
